export default __webpack_public_path__ + "static/media/no-data-admin.1e74906f.svg";